import { render } from "./BrandNavbar.vue?vue&type=template&id=26ced082&scoped=true"
const script = {}

import "./BrandNavbar.vue?vue&type=style&index=0&id=26ced082&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26ced082"]])

export default __exports__